import { combineReducers } from '@reduxjs/toolkit';
import hsPortalReducer from './slices/hsPortalSlice';
import sbqhPortalReducer from './slices/sbqhPortalSlice';
import qardanPortalReducer from './slices/qardanPortalSlice';
import PersonalQardanReducer from './slices/PersonalQardanFormSlice';

const parentReducer = combineReducers({
    hsPortal: hsPortalReducer,
    sbqhPortal: sbqhPortalReducer,
    qardanPortal: qardanPortalReducer,
    PersonalQardanForm: PersonalQardanReducer,
})

export default parentReducer;